import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { ApplypointlistPage } from './applypointlist';

@NgModule({
  declarations: [
    ApplypointlistPage,
  ],
  imports: [
    IonicPageModule.forChild(ApplypointlistPage),
  ],
})
export class ApplypointlistPageModule {}



// WEBPACK FOOTER //
// ./src/pages/applypointlist/applypointlist.module.ts